import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {first, mergeMap} from 'rxjs/operators';
import {isBackendUrl} from '../../interceptors/interceptors-helper';
import {UserHelper} from '../../model/user-helper';
import {selectUser} from '../auth-store/auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class SupportUserPartnerIdInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // only intercept own backend requests (and skip e.g. icon requests):
    if (isBackendUrl(req.url)) {
      return this.store.pipe(
        select(selectUser),
        first(),
        mergeMap(user => {
          if (!UserHelper.isCisoUser(user) && user?.activePartner && !req.headers.has('X-Zkk')) {
            const headers = {'X-Zkk': `${user.activePartner.partnerId}`};
            return next.handle(req.clone({setHeaders: headers}));
          } else {
            return next.handle(req);
          }
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
